export default __webpack_public_path__ + "static/868-bf2dc29d10bc41e7745a9aa809bee354.gif";